import { StoredFileUpload } from 'verify/lib/interfaces/fileUploads';

/**
 * For conversion of file uploads.
 */
export function dataUrlToBase64(dataUrl: string) {
  return dataUrl.replace(/^[^,]+,/, '');
}

const BASE64_MARKER = ';base64,';
export function dataUrlToBinary(dataUri: string) {
  const base64Index = dataUri.indexOf(BASE64_MARKER) + BASE64_MARKER.length;
  const base64 = dataUri.substring(base64Index);

  const raw = atob(base64);
  const array = new Uint8Array(new ArrayBuffer(raw.length));

  for (let i = 0; i < raw.length; i++) {
    array[i] = raw.charCodeAt(i);
  }
  return array.buffer;
}

/**
 * A StoredFileUpload after processing. Converts a data URL into a blob, file, or base64 string.
 * @see StoredFileUpload
 */
export type PreparedFileUpload =
  | Blob
  | File
  | { filename: string; data: string } // data is expected to be a Base64 string
  | {};

/*
 * In older versions of Windows 10 Edge, File isn't a callable constructor.
 * https://stackoverflow.com/questions/40911927/instantiate-file-object-in-microsoft-edge/43241922#43241922
 * This would error on isFunction(File) so we check the blob save method instead.
 */
export function dataUrlToFile(upload: StoredFileUpload): PreparedFileUpload {
  try {
    // Old versions of Edge, and very old versions of Safari don't have a File constructor.
    return new File([dataUrlToBinary(upload.dataUrl)], upload.filename);
  } catch {
    // Filename is defaulted to blob.jpg
    return new Blob([dataUrlToBinary(upload.dataUrl)]);
  }
}
